import { useCallback } from 'react'
import { CartApiError, resolveCart } from '../cartApi'
import { readStoredCartId, writeStoredCartId } from '../cartPersistence'
import type { Cart } from '../types'

type Params = {
  cartId: string | null
  applyCart: (nextCart: Cart) => void
}

export const useCartEnsureCart = ({ cartId, applyCart }: Params) =>
  useCallback(async () => {
    const existingId = cartId ?? readStoredCartId()
    let resolved: Cart

    try {
      resolved = await resolveCart({
        cartId: existingId ?? undefined,
      })
    } catch (error) {
      const shouldRecoverFromConflict =
        Boolean(existingId) && error instanceof CartApiError && error.status === 409

      if (!shouldRecoverFromConflict) throw error

      // Stale cart reference (guest/user switch or legacy cart ownership):
      // drop local cart id and resolve the latest cart for current identity.
      writeStoredCartId(null)
      resolved = await resolveCart()
    }

    applyCart(resolved)
    return resolved
  }, [applyCart, cartId])
